import Layout from "./layouts/Layout";
import AuthLayout from './layouts/AuthLayout';

import FileProcessingQueue from './containers/FileProcessingQueue/FileProcessingQueue';
import Dashboard from './containers/Dashboard/Dashboard';
import MediaList from "./containers/Medias/MediaList";
import MediaPurge from "./containers/MediaPurge/MediaPurge";

import StreamingLinks from "./containers/StreamingLinks/StreamingLinks";

import Unauthorized from './containers/Unauthorized/Unauthorized';
import UnauthorizedTitle from './containers/Unauthorized/UnauthorizedTitle';
import Logout from "./containers/Auth/Logout";
import Account, { AccountHeader } from "./containers/Auth/Account";
import RegisterConfirmation, { RegisterConfirmationHeader } from "./containers/Auth/RegisterConfirmation";

var routes = [
    {
        path: "/home",
        pageName: "Dashboard",
        icon: "fas fa-tachometer-alt text-warning",
        component: Dashboard,
        componentLayout: Layout,
        auth: true
    },
    {
        path: "/file-processing-queue",
        pageName: "File Processing",
        icon: "fas fa-history text-green",
        component: FileProcessingQueue,
        componentLayout: Layout,
        auth: true
    },
    {
        path: "/medias/streaming-links",
        pageName: "Streaming Links",
        icon: "fas fa-link text-yellow",
        component: StreamingLinks,
        componentLayout: Layout,
        auth: true
    },
    {
        path: "/medias/purge",
        pageName: "Purge",
        icon: "fas fa-trash text-info",
        component: MediaPurge,
        componentLayout: Layout,
        auth: true
    },
    {
        path: "/medias",
        pageName: "Media List",
        icon: "fas fa-photo-video text-info",
        component: MediaList,
        componentLayout: Layout,
        auth: true
    },
    {
        path: "/unauthorized",
        pageName: "Unauthorized",
        component: Unauthorized,
        headerComponent: UnauthorizedTitle,
        componentLayout: AuthLayout,
        auth: false,
        hidden: true
    },
    {
        path: "/login",
        pageName: "Login",
        component: Account,
        componentLayout: AuthLayout,
        headerComponent: AccountHeader,
        pageContext: "login",
        auth: false,
        hidden: true
    },
    {
        path: "/logout",
        pageName: "Logout",
        componentLayout: AuthLayout,
        headerComponent: Logout,
        auth: false,
        hidden: true
    },
    {
        path: "/register/confirm",
        pageName: "Confirmation",
        component: RegisterConfirmation,
        headerComponent: RegisterConfirmationHeader,
        componentLayout: AuthLayout,
        auth: false,
        hidden: true
    },
    {
        path: "/register",
        pageName: "Register",
        component: Account,
        headerComponent: AccountHeader,
        componentLayout: AuthLayout,
        pageContext:"register",
        auth: false,
        hidden: true
    },
];
export default routes;
